import Image from "./GoogleMaps.png";

export default function GoogleMaps() {
  return <img width="24px" height="24px" src={Image} alt="Google Maps icon" />;
}
